import { atom } from "jotai";
import { ApiUserMinimal } from "src/api/types";
import useApi, { emptyApiState } from "src/hooks/api/utils/useApi";

const stateAtom: any = atom(emptyApiState);

type Options = {
	filter?: any;
};

function useUsers(options?: Options) {
	stateAtom.onMount = (setAtom: any) => {
		setAtom({
			status: "prefetch",
		});
	};
	const query = {
		exclude: ["badges"],
		with: ["teams", "status"],
		...(options?.filter || {}),
	};
	const { state, actions, api } = useApi(stateAtom, {
		baseUrl: `/company/users`,
		query,
	});
	const users: ApiUserMinimal[] = state?.list || [];

	const invite = async (data: any) => {
		return api
			.post("/invite", data, {
				params: query,
			})
			.then(({ data }) => {
				const user = data?.data;

				actions.set((state: any) => ({
					...state,
					list: [...(state?.list || []), user],
				}));
			});
	};

	return {
		users,
		status: state.status,
		actions: {
			...actions,
			invite,
		},
		api,
	};
}

export default useUsers;
